var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"UserInfo"},[_c('UserAvatar',{staticClass:"avatar",attrs:{"avatar":_vm.user.avatar,"diameter-in-rem":2.15}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.displayName))]),_c('v-icon',[_vm._v("mdi-chevron-down")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }